import GameConfig from "../model/GameConfig";

export default class RoadBuilder {

    /**
     * 
     * @param {GameConfig} config 
     */
    constructor(gameConfig, roadAssets) {
        this._config = gameConfig;
        this._roadAssets = roadAssets;

        this._laneWidth = this._config.getValue("laneWidth");
        this._sectionLength = this._config.getValue("sectionLength");
        this._tileHeight = this._config.getValue("tileHeight");
        this._roadTypes = this._config.getValue("roadTypes");
    }

    build(sectionsContainer, markersContainer, level = 0) {
        const levelCfg = this._config.getValue("levels")[level];
        const sectionsConfig = levelCfg.sections;
        const dx = this._laneWidth;
        const dy = -this._sectionLength;
        let y = 0;
        const laneSkins = this._config.getValue("laneSkins");
        const sectionSkins = sectionsConfig.map((sectionConfig, idx) => {
            const speedIdxs = sectionConfig.speeds;
            const laneSkinIdxs = sectionConfig.laneSkins;
            if (speedIdxs.length != laneSkinIdxs.length) {
                throw new Error(`Number of speeds does not equal nr of skins in section ${idx}`);
            }
            const n = speedIdxs.length;
            const skin = sectionsContainer.addChild(new createjs.Container());
            skin.laneTypes = speedIdxs;
            const x0 = -dx * .5 * (n - 1);
            let laneIdx = 0;
            laneSkinIdxs.forEach(laneSkinIdx => {
                const tileId = laneSkins[laneSkinIdx];
                const laneSkin = this._buildLaneSkin(tileId);
                skin.addChild(laneSkin);
                laneSkin.x = x0 + laneIdx * dx;
                laneIdx++;
            });
            if (sectionConfig.marker) {
                //{"skin":"MarkerStart", "position": 1}
                const { skin: markerSkinId, position } = sectionConfig.marker;
                const markerSkin = markersContainer.addChild(new this._roadAssets[markerSkinId]());
                if (markerSkin.bg) {
                    markerSkin.bg.scaleX = speedIdxs.length;
                }
                markerSkin.y = y - position - (position < 0 ? this._sectionLength : 0);
            }
            skin.y = y;
            y += dy;
            skin.index = idx++;
            return skin;
        });

        return sectionSkins;
    }

    _buildLaneSkin(tileId) {
        const reps = Math.ceil(this._sectionLength / this._tileHeight);
        const dy = -this._tileHeight;
        const skin = new createjs.Container();
        const tileClass = this._roadAssets[tileId];
        for (let i = 0; i < reps; i++) {
            const tile = skin.addChild(new tileClass());
            tile.y = i * dy;
        }
        return skin;
    }

}